const { send: ajax } = require('client/lib/request')
const { track } = require('client/lib/analytics')

const API = {
  createMix(name, isRecommended = false, pageContext = {}) {
    return ajax({
      url: '/api/v0.1/mixes',
      method: 'post',
      data: {
        name: name.trim(),
        description: '',
        recommended: isRecommended,
        'page_context': pageContext
      }
    })
    .then(createResponse => {
      return track('create-mix', {
        name: createResponse.name,
        'mix_id': createResponse.id,
        metabase: {
          'actioned_object_type': 'mix',
          'actioned_object_id': createResponse.id,
          'actioned_element_name': createResponse.name
        }
      })
      .then(() => {
        return createResponse
      })
    })
  },

  addToMix(mixId, urlId, pageContext = {}) {
    return ajax({
      url: `/api/v0.1/mix/url/${mixId}`,
      method: 'post',
      data: {
        'url_id': urlId,
        'page_context': pageContext
      }
    })
    .then(addResponse => {
      return track('add-url-to-mix', {
        'url_id': urlId,
        mixId: mixId
      })
      .then(() => {
        return addResponse
      })
    })
  },

  removeFromMix(mixId, urlId, pageContext = {}) {
    return ajax({
      url: `/api/v0.1/mix/url/${mixId}`,
      method: 'delete',
      data: {
        'url_id': urlId,
        'page_context': pageContext
      }
    })
    .then(removeResponse => {
      return track('remove-url-from-mix', {
        'url_id': urlId,
        mixId: mixId
      })
      .then(() => {
        return removeResponse
      })
    })
  }
}

module.exports = { API }
